import React from 'react';
import {

    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Chip,
    Box,
} from '@mui/material';

// Sample skill record data
const skillRecord = {
    id: 42,
    name_zh: "可信Jumping Jack",
    name_en: "Hoshun Jump Jack",
    code: "hoshun_jumping_jack",
    fitness_type: "hoshun_jumping_jack",
    fitness_type_en: "Hoshun Jump Jack",
    fitness_type_zh: "可信Jumping Jack",
    unit: "score",
    decimal_place: 0,
    rank_direction: "desc",
    support_ipad: true,
    color: "blue",
    result: [
        {
            rank: 1,
            score: "22",
            unit: "",
            participants: [
                { type: "member", member_id: "18357", name: "趙 焌 傑", school_cls: "2B" },
                { type: "member", member_id: "18713", name: "劉 嘉 妍", school_cls: "5A" },
                { type: "member", member_id: "18842", name: "趙 芷 雯", school_cls: "4B" }
            ]
        },
        {
            rank: 2,
            score: "21",
            unit: "",
            participants: [
                { type: "member", member_id: "18371", name: "陸 宇 軒", school_cls: "2B" },
                { type: "member", member_id: "18397", name: "簡 梓 雅", school_cls: "2C" }
            ]
        },
        {
            rank: 3,
            score: "20",
            unit: "",
            participants: [
                { type: "member", member_id: "18795", name: "羅 梓 瑜", school_cls: "5D" }
            ]
        },
        {
            rank: 4,
            score: "19",
            unit: "",
            participants: [
                { type: "member", member_id: "18467", name: "陳 詩 妍", school_cls: "3B" },
                { type: "member", member_id: "18484", name: "孫 銘 浩", school_cls: "3B" }
            ]
        },
        {
            rank: 5,
            score: "18",
            unit: "",
            participants: [
                { type: "member", member_id: "18763", name: "何 紫 慧", school_cls: "5C" },
                { type: "member", member_id: "18885", name: "馬 福 熙", school_cls: "4D" }
            ]
        },
        {
            rank: 6,
            score: "17",
            unit: "",
            participants: [
                { type: "member", member_id: "18489", name: "王 梓 蕘", school_cls: "3B" },
                { type: "member", member_id: "18840", name: "陳 彥 羽", school_cls: "4B" },
                { type: "member", member_id: "18891", name: "黃 凱 婷", school_cls: "4D" }
            ]
        }
    ]
};


function participantInfo(participantInfo) {
    console.debug("participantInfo: ", participantInfo);

    let type = participantInfo.type || "";

    if (type == "member") {
        let classInfo = participantInfo.school_cls || "";
        if(classInfo == null) {
            classInfo = "";
        }
        let name = participantInfo.name || "";
        if(name == null) {
            name = "";
        }
        if(classInfo !== "") {  
            return `${name} (${classInfo})`;
        }

        if(name === "") {  
            name = "未知參加者";
        }

        return name;
    } else {
        return participantInfo.name;
    }
}

function createParticipantBlock(participants) {

    return (
        <Box display="flex" flexWrap="wrap" gap={2}>
            {participants.map((participant, index) => (
                <Chip sx={{ fontSize: "1.0rem" }} label={participantInfo(participant)} />
            ))}
        </Box>
    )
    // return participants.map((p) => (
    //     <div key={p.member_id}>
    //         {p.name} ({p.school_cls})
    //     </div>
    // ));
}

export default function SchoolLeaderboardTable({ leaderboardSkillRecord }) {
    const hasResult = leaderboardSkillRecord && leaderboardSkillRecord.result && leaderboardSkillRecord.result.length > 0;

    if (!hasResult) {
        return (<Box sx={{ marginTop: 2, marginBottom: 4 }}>
            <Typography variant="h6" gutterBottom>
                {leaderboardSkillRecord.name_zh} ( {leaderboardSkillRecord.name_en} )
            </Typography>
            <Typography variant="body1">未有任何排行榜數據</Typography>
        </Box>);
    }

    const cellStyle = { padding: 1, margin: 0, borderBottom: "1px solid #ddd" };

    return (
        <Box sx={{ marginTop: 2, marginBottom: 4 }}>
            <Typography variant="h6" gutterBottom>
                {leaderboardSkillRecord.name_zh} ( {leaderboardSkillRecord.name_en} )
            </Typography>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{backgroundColor: '#fca'}}>
                        <TableRow>
                            <TableCell align="center">排名</TableCell>
                            <TableCell align="center">分數</TableCell>
                            <TableCell align="center">參加者</TableCell>
                            {/* <TableCell align="center">班別</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {leaderboardSkillRecord.result.map((row) =>
                        (
                            <TableRow key={row.rank} sx={{ padding: 0 }} >
                                <TableCell align="center" sx={cellStyle}>
                                    {row.rank}
                                </TableCell>
                                <TableCell align="center" sx={cellStyle}>{row.score}</TableCell>
                                <TableCell align="center" sx={cellStyle}>
                                    {createParticipantBlock(row.participants)}
                                </TableCell>
                            </TableRow>
                        )

                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}